type PanelId = 'chat' | 'history' | 'debugMenu';

function storageKey(panelId: PanelId): string {
  return `turfmaster_panelExpanded_${panelId}`;
}

export function loadPanelExpanded(panelId: PanelId): boolean | null {
  if (typeof window === 'undefined' || !window.localStorage) return null;
  try {
    const raw = window.localStorage.getItem(storageKey(panelId));
    if (raw === null) return null;
    if (raw === 'yes') return true;
    if (raw === 'no') return false;
    return null;
  } catch {
    return null;
  }
}

export function savePanelExpanded(panelId: PanelId, value: boolean): void {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    window.localStorage.setItem(storageKey(panelId), value ? 'yes' : 'no');
  } catch {
    // ignore
  }
}

const DEBUG_MENU_ACCORDION_KEY = 'turfmaster_debugMenu_accordion';

export function loadDebugMenuAccordionOpen(): string[] | null {
  if (typeof window === 'undefined' || !window.sessionStorage) return null;
  try {
    const raw = window.sessionStorage.getItem(DEBUG_MENU_ACCORDION_KEY);
    if (raw === null) return null;
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return null;
    return parsed.filter((item): item is string => typeof item === 'string');
  } catch {
    return null;
  }
}

export function saveDebugMenuAccordionOpen(values: string[]): void {
  if (typeof window === 'undefined' || !window.sessionStorage) return;
  try {
    window.sessionStorage.setItem(DEBUG_MENU_ACCORDION_KEY, JSON.stringify(values));
  } catch {
    // ignore
  }
}
